// src/components/ReCaptchaComponent.js
import React, { useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const ReCaptchaComponent = ({ onTokenReceived }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleRecaptcha = async () => {
    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      return;
    }
    const token = await executeRecaptcha('login'); // 'login' ay ang action name
    onTokenReceived(token);
  };

  useEffect(() => {
    handleRecaptcha();
  }, [executeRecaptcha]);

  return null; // Hindi ito nagre-render ng anumang UI
};

export default ReCaptchaComponent;